<script setup lang="ts">
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import HighestFireOutbreakMarker from './HighestFireOutbreakMarker.vue'
import FireOutbreakMarker from './FireOutbreakMarker.vue'
import Tooltip from '@/components/ui/tooltip/Tooltip.vue'
import FireOutbreakTooltip from './FireOutbreakTooltip.vue'

defineProps<{
	alert: FireOutbreak
}>()

function getMarkerContainer(tippyInstance: any): HTMLElement | null {
	return tippyInstance.reference?.closest('.mapboxgl-marker') ?? null
}

const tooltipOptions = {
	trigger: 'click',
	onShow(instance: any) {
		const marker = getMarkerContainer(instance)
		if (marker) marker.style.zIndex = '10'
	},
	onHide(instance: any) {
		const marker = getMarkerContainer(instance)
		if (marker) marker.style.zIndex = ''
	},
}
</script>

<template>
	<div class="w-fit">
		<tooltip
			:options="tooltipOptions"
			append-to="parent"
		>
			<template #trigger>
				<div @click="alert.haveSeenAlert()">
					<highest-fire-outbreak-marker v-if="!alert.seen" />
					<fire-outbreak-marker v-else />
				</div>
			</template>

			<fire-outbreak-tooltip :alert="alert" />
		</tooltip>
	</div>
</template>

<style scoped>
svg {
	cursor: pointer;
}
</style>
